import ApolloClient from 'apollo-boost';
import fetch from 'isomorphic-fetch';

const apiHost = process.env.NODE_ENV === 'development'
  ? process.env.GATSBY_STAGING_API_URL : process.env.GATSBY_PROD_API_URL;

export const client = new ApolloClient({
  uri: `${apiHost}api/v1/graphql`,
  fetch,
});
